var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasOverflow)?_c('el-tooltip',{attrs:{"popper-class":"overflow-tooltip","content":_vm.text,"placement":"top","open-delay":400}},[_c('div',{staticClass:"overflow-text"},[_vm._v("\n      "+_vm._s(_vm.truncatedText)+"\n    ")])]):[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }